import { useState } from 'react'

function Login({ supabase }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleLogin() {
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fafafa'
    }}>
      <div style={{
        background: '#fff',
        border: '0.5px solid #e5e5e5',
        borderRadius: '12px',
        padding: '40px',
        width: '360px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#E24B4A' }}></div>
          <span style={{ fontSize: '18px', fontWeight: '500' }}>Redeye</span>
        </div>
        <p style={{ fontSize: '14px', color: '#888', marginBottom: '8px' }}>Sign in to your account</p>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{
            padding: '10px 14px',
            border: '0.5px solid #e5e5e5',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{
            padding: '10px 14px',
            border: '0.5px solid #e5e5e5',
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none'
          }}
        />
        {error && <p style={{ color: '#E24B4A', fontSize: '13px' }}>{error}</p>}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            padding: '10px',
            background: '#E24B4A',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer'
          }}
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </div>
    </div>
  )
}

export default Login